import _ from 'lodash';

/**
 * Removes all instances of a property from an object.
 * WARNING: Doesn't work on duplicate sub-objects (e.g. two objects of the same name)
 * @param obj Object to remove from
 * @param propToDelete Property to delete
 */
export function removeProp(obj: {}, propToDelete: string) {
    for (const property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (typeof obj[property] === "object") {
                removeProp(obj[property], propToDelete);
            } else {
                if (property === propToDelete) {
                    delete obj[property];
                }
            }
        }
    }
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
 export function difference(fromDiff: {}, toDiff: {}): { original: {}, new: {} } {
    function changes(fromDiff2: {}, toDiff2: {}) {
        return _.transform(fromDiff2, (result, value, key) => {
            if (!_.isEqual(value, toDiff2[key])) {
                result[key] = (_.isObject(value) && _.isObject(toDiff2[key])) ? changes(value, toDiff2[key]) : value;
            }
        });
    }
    return {
        original: changes(fromDiff, toDiff),
        new: changes(toDiff, fromDiff),
    };
}

export interface AtomicObject {
    [key: string]: string | number | AtomicObject | null;
}

export function flattenObject(nestedMessages: AtomicObject | any, prefix: string = ""): { [key: string]: string | number | boolean | null } {
    return Object.keys(nestedMessages).reduce((messages: string | { [key: string]: string }, key: string) => {
        const value: AtomicObject | string | number | null = nestedMessages[key];
        const prefixedKey: string = prefix ? `${prefix}.${key}` : key;

        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null) {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenObject(value, prefixedKey));
        }

        return messages;
    }, {});
}



// WEBPACK FOOTER //
// ./src/utils/Object.ts